const slideFromLeft = (delay = 0.2) => ({
    hidden: { opacity: 0, x: -100 },
    visible: { opacity: 1, x: 0, transition: { delay } },
});

const slideFromRight = (delay = 0.2) => ({
    hidden: { opacity: 0, x: 100 },
    visible: { opacity: 1, x: 0, transition: { delay } },
    exit: { opacity: 0, x: -12, transition: { delay } },
});

const slideInDown = (delay = 0.2) => ({
    hidden: { opacity: 0, y: -100 },
    visible: { opacity: 1, y: 0, transition: { delay } },
    exit: { opacity: 0, y: 12, transition: { delay } },
});

const slideInUp = (delay = 0.2) => ({
    hidden: { opacity: 0, y: 100 },
    visible: { opacity: 1, y: 0, transition: { delay } },
    exit: { opacity: 0, y: -12, transition: { delay } },
});

const slide = { slideFromLeft, slideFromRight, slideInDown, slideInUp };

export default slide;
